import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
//import "buefy/dist/buefy.css";
import "./assets/style.css";
import "./assets/tally-theme.css";
import VueI18n from "vue-i18n";
import { messages } from "@/i18n/index";
import "@mdi/font/css/materialdesignicons.css";
import VueMeta from "vue-meta";
import { StripePlugin } from "@vue-stripe/vue-stripe";
import "vue-progress-path/dist/vue-progress-path.css";
import VueProgress from "vue-progress-path";
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'

const options = {
    pk: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
    apiVersion: "3",
};

Vue.use(StripePlugin, options);
Vue.use(VueTelInput)

Vue.use(VueI18n);
Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true,
});
Vue.use(Buefy, {});

Vue.use(VueProgress, {
    defaultShape: "circle",
});
Vue.config.productionTip = false;
const i18n = new VueI18n({
    locale: navigator.language,
    messages,
});

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
